import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'itpx-content-tile-loading',
  templateUrl: './content-tile-loading.component.html',
  styleUrls: ['../deliverable-tile-loading/deliverable-tile-loading.component.css', '../../common/style.css', './content-tile-loading.component.css']
})
export class ContentTileLoadingComponent implements OnInit {
  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/core/components/workflow-new/material/content-tile-loading/content-tile-loading.component.ts